<template>
  <div class="document" style="height: 100%">
    <div class="header">
      <es-header>
        <template #header>
          <div class="header-title">
            Recent History Records
          </div>
        </template>
        <template #actions v-if="recentHistoryRecords.length">
          <ul>
            <li class="p-narrow no-border">
              <div class="list-content">
                <router-link
                    :to="{
                    name: 'PidHistoryRecords',
                    query: {
                      retired: isRetired,
                    },
                  }"
                >
                  <font-awesome-icon
                    :icon="['far', 'angle-double-right']"
                    size="2x"
                    title="View Details"
                  />
                </router-link>
              </div>
            </li>
          </ul>
        </template>
      </es-header>
    </div>
    <es-exception
      v-if="!recentHistoryRecords.length"
      exceptionMessage="No History for this Person."
      margin="3rem"
    />
    <table v-else class="table is-fullwidth">
      <thead>
        <tr class="padding-left--small">
          <th title="Update Date">
            Update Date
          </th>
          <th
            v-if="fieldEnabled('FIRST_NAME')
              || fieldEnabled('LAST_NAME')"
            title="Name"
          >
            Name
          </th>
          <th title="Actions" align="right">
            Actions
          </th>
        </tr>
      </thead>
      <template>
        <person-profile-recent-history-overview-row
          v-for="(recentHistoryRecord, index) in filteredHistoryRecords"
          :key="index"
          :id="id"
          :isRetired="isRetired"
          :person="person"
          :historyRecord="recentHistoryRecord"
        />
      </template>
    </table>
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAngleDoubleRight,
} from '@fortawesome/pro-regular-svg-icons';
import { mapGetters } from 'vuex';
import EsException from '@/components/EsException.vue';
import EsHeader from '@/components/EsHeader.vue';
import FieldLabels from '@/mixins/FieldLabels';
import PersonProfileRecentHistoryOverviewRow from '@/components/PersonProfileRecentHistoryOverviewRow.vue';

library.add(
  faAngleDoubleRight,
);

export default {
  components: {
    PersonProfileRecentHistoryOverviewRow,
    EsException,
    EsHeader,
  },
  mixins: [
    FieldLabels,
  ],
  props: {
    id: {
      type: String,
      required: true,
    },
    isRetired: {
      type: Boolean,
      default: false,
    },
    person: {
      type: Object,
      required: true,
    },
    recentHistoryRecords: {
      type: Array,
      required: true,
    },
  },
  computed: {
    ...mapGetters('propertiesModule', [
      'properties',
    ]),
    ...mapGetters('fieldLabelsModule', [
      'getFieldEnabledForPersonType',
    ]),
    filteredHistoryRecords() {
      return this.recentHistoryRecords.slice(0, 6);
    },
  },
  methods: {
    fieldEnabled(code) {
      return this.getFieldEnabledForPersonType(code, 'ASSIGN', this.person.personType);
    },
  },
};
</script>

<style lang="css" scoped>
</style>
